import { Button, Modal, ModalBody, ModalHeader, Tooltip } from 'reactstrap';
import styles from './Share.module.scss';
import {useToggle} from "../../../global/utils/hooks/useToggle";
import { useContext } from 'react';
import { UserContext } from '../../../global/globalContext/context';
import { showMsg } from '../../../global/langs/langs';
import { useState } from 'react';
import {EmailShareButton, FacebookShareButton,TelegramShareButton,TwitterShareButton,ViberShareButton, WhatsappShareButton} from "react-share";
import {EmailIcon, FacebookIcon, TelegramIcon, ViberIcon, WhatsappIcon, XIcon} from "react-share";
  
export default function Share({title}) {
    const { lang } = useContext(UserContext);

    const [successMsg, setSuccessMsg] = useState();

    const [tooltipOpen, setTooltipOpen, toggleTooltipOpen] = useToggle(false);
    const [modal,  setModal, toggleModal] = useToggle(false);

    const shareUrl = window.location.href;

    async function shareHandleClick() {
        await navigator.clipboard.writeText(shareUrl);
        setSuccessMsg("Copied");
        setTooltipOpen(true);
        setTimeout(function(){
            setTooltipOpen(false);
            setSuccessMsg('');
        },2000);
    }

  return (
    <>
        <Modal isOpen={modal} toggle={toggleModal} >
            <ModalHeader toggle={toggleModal}>
                Share
            </ModalHeader>
            <ModalBody>                    
                <div className={`d-flex flex-row flex-wrap justify-content-center`}>
                    
                        <div className={`text-lighter-color ${styles.shareActions} me-4 mb-2`} >
                            <Button 
                                className={`${styles.actionIcon} bg-primary border-0`}
                                onClick={shareHandleClick}
                                rel="noreferrer"
                                id='sharePage'
                                >
                                <i className={`bi bi-link`}></i>
                            </Button>
                        </div>
                        <div className={`text-lighter-color ${styles.shareActions} text-center me-4 mb-2`} >
                            <TelegramShareButton
                                url={shareUrl}
                                title={title}
                                className={``}
                                >
                                <TelegramIcon size={32} round />
                            </TelegramShareButton>
                        </div>

                        <div className={`text-lighter-color ${styles.shareActions} text-center me-4 mb-2`} >
                            <WhatsappShareButton
                                url={shareUrl}
                                title={title}
                                className={``}
                                >
                                <WhatsappIcon size={32} round />
                            </WhatsappShareButton>
                        </div>
                        
                        <div className={`text-lighter-color ${styles.shareActions} text-center me-4 mb-2`} >
                            <FacebookShareButton 
                                url={shareUrl} 
                                className="Demo__some-network__share-button">
                                <FacebookIcon size={32} round />
                            </FacebookShareButton>
                        </div>
                        <div className={`text-lighter-color ${styles.shareActions} text-center me-4 mb-2`} >
                            <EmailShareButton
                                url={shareUrl}
                                subject={title}
                                body="body"
                                className="Demo__some-network__share-button"
                                >
                                <EmailIcon size={32} round />
                            </EmailShareButton>
                        </div>
                        <div className={`text-lighter-color ${styles.shareActions} text-center me-4 mb-2`} >
                            <ViberShareButton 
                                url={shareUrl} 
                                title={title} 
                                className="Demo__some-network__share-button">
                                <ViberIcon size={32} round />
                            </ViberShareButton>
                        </div>
                        <div className={`text-lighter-color ${styles.shareActions} text-center me-4 mb-2`} >
                            <TwitterShareButton
                                url={shareUrl}
                                title={title}
                                className="Demo__some-network__share-button"
                                >
                                <XIcon size={32} round />
                            </TwitterShareButton>
                        </div>
                    </div>
            </ModalBody>
        </Modal>
        <div className={`text-center px-2 px-sm-4 my-3 ${styles.rightDivider} ${styles.share} d-inline-block`}>
            {
                successMsg && (
                    <Tooltip
                        isOpen={tooltipOpen}
                        target='sharePage'>
                        {successMsg}
                    </Tooltip>
                )
                
            }
            <Button 
                className={`
                    ${styles.actionIcon} 
                    bg-transparent 
                    border-0`}
                onClick={toggleModal}
                rel="noreferrer"
                >
                <i className={`bi bi-share`}>
                </i>
            </Button>
            <div className={`${styles.actionTitle}`}>
                {showMsg('share', lang)}
            </div>
        </div>
    </>
  )
}
